'use client'

import { Header } from '@/components/Header/Header'
import { SiteFooter } from '@/components/SiteFooter'
import useIsAppEligibilityPage from '@/hooks/useIsAppEligibilityPage'
import useIsBiometricConsentPage from '@/hooks/useIsBiometricConsentPage'
import useIsNativeBlogPage from '@/hooks/useIsNativeBlogPage'

interface ConditionalLayoutProps {
  children: React.ReactNode
}

export function ConditionalHeaderFooter({ children }: ConditionalLayoutProps) {
  const isEligibilityPage = useIsAppEligibilityPage()
  const isNativeBlogPage = useIsNativeBlogPage()
  const isBiometricConsentPage = useIsBiometricConsentPage()

  if (isEligibilityPage || isNativeBlogPage || isBiometricConsentPage) {
    return <>{children}</>
  }

  return (
    <>
      <Header />
      {children}
      <SiteFooter />
    </>
  )
}
